module.exports = __webpack_public_path__ + "static/img/gaozhongdili9.e11f1336.jpg";